"use strict";

require("core-js/modules/es.array.iterator");

var isIterable = require("../Strict/isIterable.js");

var entriesL = require("../Lazy/entriesL.js");

var mapEntriesL = require("../Lazy/mapEntriesL.js");

const baseCallEach = (map, object) => (fs, ...args) => isIterable(fs) ? map(f => f(...args), fs) : object(mapEntriesL(f => f(...args), entriesL(fs)));

module.exports = baseCallEach;